module.exports = __webpack_public_path__ + "img/HongKongTrust1.d2b87bfe.png";